






















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import CommonButton from '@/components/button/CommonButton.vue';
import IconButton from '@/components/button/IconButton.vue';

@Component({
    components: {
        IconButton,
        CommonButton
    }
})
export default class ItemAction extends Vue {
    @Prop({default: false}) protected readonly disabled: boolean;
    @Prop({default: false}) protected readonly readonly: boolean;
    @Prop({default: false}) protected readonly newItem: boolean;
    @Prop({default: false}) private readonly hasNotation: boolean;
    private visible = false;

    get notationVisible() {
        return this.hasNotation;
    }

    get isDisabled() {
        return this.disabled;
    }

    get isReadOnly() {
        return this.readonly;
    }

    get isActive() {
        return !this.isDisabled && !this.isReadOnly;
    }

    get isNew() {
        return this.newItem;
    }

    public onOpen() {
        this.visible = !this.visible;
    }

    public onAuditTrail() {
        this.$emit('auditTrail');
        this.hide();
    }

    public onErase() {
        this.$emit('erase');
        this.hide();
    }

    public onToggleNotation() {
        this.$emit('toggleNotation');
        this.hide();
    }

    public hide() {
        this.visible = false;
    }
}
